import {splitCamelCase} from '@/helpers/Utils';

export default class VehicleType {

    constructor(id, key) {
        this.id = id
        this.key = key
        this.name = splitCamelCase(key)
    }

}
